import type { IDataEditState, ITableEditUnionType } from '@/store/models/tableEdit.model'
import { TableDataCons } from '@/store/constant/table.constant'

const intialState: IDataEditState = {
    table1EditData: {
        key: '',
        name: '',
        workgroup: '',
        '2021': '',
        '2022': '',
        '2023': ''
    },
    table2EditData: {
        id: -1,
        version: 0,
        buStakeholder: '',
        description: '',
        developedBy: '',
        techLevel: 1,
        maturity: '',
        priority: '',
        quantitativeIndicators: '',
        requirementSource: '',
        researchForms: '',
        resourceNeeded: -1,
        subsidiary: '',
        techClassId: -1,
        classificationName: '',
        techName: '',
        techPtn: '',
        tmtapproval: '',
        toolsEquipment: '',
        techYearQuarters: []
    },
    workgroupList: [],
    keyRoadMap: [
        {
            id: 0,
            parentId: 0,
            projectInfo: 'projectInfo',
            releaseStatus: 'dsf',
            techName: 'Data storage capacity extension support',
            techPtn: 'techPtn',
            workGroupId: 102,
            year: 2021,
            loading: true
        },
        {
            id: 1,
            parentId: 0,
            projectInfo: 'projectInfo2',
            releaseStatus: 'dsfgds',
            techName: 'Support data of closed loop algorithm',
            techPtn: 'techPtn2',
            workGroupId: 102,
            year: 2021,
            loading: true
        }
    ],
    keyRoadMapPagination: {
        pageSize: 10,
        total: 0,
        pageIndex: 1
    },
    classficationPagination: {
        pageSize: 10,
        total: 0,
        pageIndex: 1
    },
    projectInfoPagination: {
        pageSize: 10,
        total: 0,
        pageIndex: 1
    },
    techClassification: [],
    projectInfo: [],
    dicClass: {}
}

export default function tableEditReducer(
    state = intialState,
    action: ITableEditUnionType
): any {
    switch (action.type) {
        case TableDataCons.SETEDITDATA:
            return {
                ...state,
                table1EditData: {
                    ...state.table1EditData,
                    ...action.payload
                }
            }
        case TableDataCons.SETEDITDATA2:
            return {
                ...state,
                table2EditData: action.payload
            }
        case TableDataCons.CLEAREDITDATA2:
            return {
                ...state,
                table2EditData: {}
            }
        case TableDataCons.SETWORKGROUPCLASS:
            return {
                ...state,
                workgroupList: action.payload
            }
        case TableDataCons.SETKEYROADMAP:
            return {
                ...state,
                keyRoadMap: action.payload
            }
        case TableDataCons.SETKEYROADMAPPAGINATION:
            return {
                ...state,
                keyRoadMapPagination: {
                    ...state.keyRoadMapPagination,
                    ...action.payload
                }
            }
        case TableDataCons.SETCLASSIFICATIONPAGINATION:
            return {
                ...state,
                classficationPagination: {
                    ...state.classficationPagination,
                    ...action.payload
                }
            }
        case TableDataCons.SETPROJECTINFOPAGINATION:
            return {
                ...state,
                projectInfoPagination: {
                    ...state.projectInfoPagination,
                    ...action.payload
                }
            }
        case TableDataCons.SETTECHCLASSIFICATION:
            return {
                ...state,
                techClassification: action.payload
            }
        case TableDataCons.SETPROJECTINFO:
            return {
                ...state,
                projectInfo: action.payload
            }
        case TableDataCons.SETDICCLASSLIST:
            return {
                ...state,
                dicClass: action.payload
            }
        case TableDataCons.CLEARSTORE:
            return intialState
        default:
            return state
    }
}
